export default "__VITE_ASSET__7SrI95$Z__"